/* Client-side "Highest Rated" sort for the DEFAULT/shared collection
   template. ROUND 44. Generalized copy of assets/ccg-sort.js (Custom
   Collection Grid, round 14) — same mechanism, own class/global names
   (mcs- / MCS_RATINGS instead of ccg- / CCG_RATINGS) so the two stay
   independently editable.

   All the OTHER sort options (Featured, Newest, Price, Best Selling,
   Product Name A-Z/Z-A) are native Shopify `sort_by` values, applied
   server-side via a normal form submit + page reload (see
   snippets/main-collection-sort.liquid). "Highest Rated" has no native
   Shopify sort_by equivalent, so it's handled entirely here: it reorders
   the product cards already on the page, using each product's real star
   rating (product.metafields.reviews.rating.value.value), rendered once
   per page load as window.MCS_RATINGS by sections/main-collection.liquid.

   Only ever loaded from sections/main-collection.liquid (the default
   collection template's section) — it never loads alongside the Custom
   Collection Grid template, so no scoping class is needed the way
   ccg-sort.js scopes to .custom-grid-page.

   Known limitation, same as ccg-sort.js: only reorders whatever products
   are already rendered in the DOM for the current page/pagination slice.
   It doesn't fetch additional pages, and the sort isn't reflected in the
   URL, so it resets on reload/pagination. */
(function () {
  function getRatings() {
    return (window.MCS_RATINGS && typeof window.MCS_RATINGS === 'object') ? window.MCS_RATINGS : {};
  }

  function sortByRating() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;
    var ratings = getRatings();

    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.querySelector && el.querySelector('.product-card[data-handle]');
    });

    items.sort(function (a, b) {
      var handleA = a.querySelector('.product-card[data-handle]').getAttribute('data-handle');
      var handleB = b.querySelector('.product-card[data-handle]').getAttribute('data-handle');
      var ratingA = parseFloat(ratings[handleA]) || 0;
      var ratingB = parseFloat(ratings[handleB]) || 0;
      return ratingB - ratingA;
    });

    var frag = document.createDocumentFragment();
    for (var i = 0; i < items.length; i++) frag.appendChild(items[i]);
    grid.appendChild(frag);
  }

  function markActive(trigger) {
    var list = trigger.closest('.mcs-sort-dropdown');
    if (!list) return;
    var options = list.querySelectorAll('.mcs-sort-option');
    for (var i = 0; i < options.length; i++) options[i].classList.remove('is-active');
    trigger.classList.add('is-active');
    var radios = list.querySelectorAll('input[name="sort_by"]');
    for (var j = 0; j < radios.length; j++) radios[j].checked = false;
  }

  function closeDropdown(trigger) {
    var details = trigger.closest('details.mcs-dropdown');
    if (details) details.open = false;
  }

  function init() {
    var triggers = document.querySelectorAll('.js-mcs-sort-rating');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function (e) {
        sortByRating();
        markActive(e.currentTarget);
        closeDropdown(e.currentTarget);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
